import React, {Component} from 'react';
import { connect, Provider } from 'react-redux';
import $ from 'jquery';

import Foto from '../helpers/foto.js';

export class BigP extends Component {
  state = {
    w: 100,
    h: 100,
    imgh: 100,
    }
  render() {
    var p = this.props.posicion;
    var f = this.props.fotos[p];

    const Icons = this.props.icons;

    return(
      // UGH: deberia llamar a this.props.close
      f ?
      <div>
        <div className="row" style={{textAlign: "center"}}>
          <div className="col-md-12">
            <button className="close" onClick={() => this.props.set_posicion(p, false)}>&times;</button>
            <h4>{f.i} | {Foto.fecha(f)} (<a onClick={this.buscar_por_foto}>{Config.fotografos[f.g].codigo}</a>)</h4>
          </div>
        </div>
        <div className="row" style={{textAlign: "center", position: "relative", height: this.h}}>
          <div className="col-md-12 fotobig" ref="foto">
            <img key={f.i} src={Foto.URL(f, "big")} ref="img_foto" onLoad={this.recalc_pos} height={this.state.imgh}/>
            <div style={{position: "absolute", top:0, left:0, width: this.state.w/2, height: this.state.h}} onClick={() => this.prev()}/>
            <div style={{position: "absolute", top:0, left:this.state.w/2, width: this.state.w/2, height: this.state.h}} onClick={() => this.next()}/>
          </div>
        </div>
        <div className="pager">
          <div className="col-md-4" style={{textAlign: "left"}}>
            { this.props.posicion > 0 ?
            <button onClick={() => this.prev()}>
              <i className="fa fa-arrow-left"/>
              &nbsp;
              <img src={Foto.URL(this.props.fotos[this.props.posicion-1], "small")}/>
            </button>
            : null }
          </div>
          <div className="col-md-4" style={{textAlign: "center"}}>
            <Icons foto={f} set_active={() => 0}/>
          </div>
          <div className="col-md-4" style={{textAlign: "right"}}>
            { this.props.posicion < this.props.fotos.length-1 ?
            <button onClick={() => this.next()}>
              <img src={Foto.URL(this.props.fotos[this.props.posicion+1], "small")}/>
              &nbsp;
              <i className="fa fa-arrow-right"/>
            </button>
            : null }
          </div>
        </div>
      </div>
      : <div>No hay fotos</div>
      );
    }
  componentWillReceiveProps(newprops) {
    if (newprops.fotos.length == 0)
      newprops.close();
    }
  componentDidMount() {
    window.addEventListener("resize", this.recalc_pos);
    $(document.body).on('keydown', this.handleKeyDown.bind(this));
    this.recalc_pos();
    }
  componentWillUnmount() {
    window.removeEventListener("resize", this.recalc_pos);
    $(document.body).off('keydown');
    }
  recalc_pos = () => {
    if (this.refs && this.refs.foto && this.refs.img_foto) {
      var dom_img = this.refs.img_foto;
      var iw = dom_img.naturalWidth;
      var ih = dom_img.naturalHeight;
      if (iw==0) {
        iw = 1;
        ih = 1;
        }

      var dom_f = this.refs.foto;
      const tw = dom_f.offsetWidth;
      const th = window.innerHeight-$(dom_f).offset().top-160;

      var imgh;

      if (ih*this.w/iw <= this.h) {
        imgh = ih*tw/iw;
      } else {
        imgh = th-10;
        }
      this.setState({w: tw, h: th, imgh: imgh});
      }
    }
  handleKeyDown(e) {
    console.log("handleKeyDown", e);
    if( e.keyCode == 37 ) {
      this.prev();
    } else if ( e.keyCode == 39 ) {
      this.next();
    } else if ( e.keyCode == 27 ) {
      this.props.set_posicion(this.props.posicion, false);
      }
    }
  prev() {
    if (this.props.posicion > 0)
      this.props.set_posicion(this.props.posicion-1, true);
    }
  next() {
    console.log("BIGP next", this.props);
    const p = this.props.posicion+1;
    if (p < this.props.fotos.length)
      this.props.set_posicion(p, true);
    }
  buscar_por_foto() {
    this.props.buscadorActions.search({foto: this.props.fotos[this.props.posicion].i});
    }
  };
